__turbopack_context__.v({
  "CreditPanel": "product-guarantee-module-scss-module__19Yria__CreditPanel",
  "CreditPanel__IconList": "product-guarantee-module-scss-module__19Yria__CreditPanel__IconList",
  "CreditPanel__IconWrap": "product-guarantee-module-scss-module__19Yria__CreditPanel__IconWrap",
  "GuaranteeLink": "product-guarantee-module-scss-module__19Yria__GuaranteeLink",
  "ProductGuaranteeTooltip": "product-guarantee-module-scss-module__19Yria__ProductGuaranteeTooltip",
});
